module.exports = __webpack_public_path__ + "static/media/VectorPointConcluido6.15b29bfe.svg";